import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { right } from '@popperjs/core';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../endpoints/endpoint';
import { NetworkService } from 'src/app/services/network.service';
import { Utility } from '../../utility/utility';
import { environment } from '../../../environments/environment';
import { GenericResponseDto } from '../gestione-utenti/gestione-utenti.costants';

@Component({
  selector: 'app-customer-data-entry',
  templateUrl: './customer-data-entry.component.html',
  styleUrls: ['./customer-data-entry.component.css']
})
export class CustomerDataEntryComponent implements OnInit, OnDestroy {

  //listCustomer: CreateCustomerDto[];
  destroy$ = new Subject<boolean>();
  listCustomerView: any[] = [];
  viewAggiungiCountry: boolean = false;
  viewAggiungiAffiliate: boolean = false;
  viewAggiungiDepartment: boolean = false;


  @ViewChild('confirmEliminaCustomer') confirmEliminaCustomerModal: NgbModalRef;
  @ViewChild('updateCustomer') updateCustomerModal: NgbModalRef;
  modalReference: NgbModalRef;
  deleteResponse: GenericResponseDto;

  settings = {
    actions: {
      custom: [
        {
          name: 'editAction',
          title: '<i class="fa-solid fa-pen-to-square" title="Edit"></i>'
        },
        {
          name: 'deleteAction',
          title: '&nbsp;<i class="far fa-trash-alt" title="Delete" style="margin-left:10%;"></i>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: right,
    },
    columns: {
      globalCustomerId: {
        title: 'GlobalCustomerId'
      },
      globalCustomerName: {
        title: 'GlobalCustomerName'
      },
      operator: {
        title: 'Lead Operator',
        valuePrepareFunction: (operator: string) => {
          return operator === 'IMSA' ? 'DEUTSCHE TELEKOM' : operator;
        }
      },
      dataLastUpdate: {
        title: 'Date Last Update',
        compareFunction(direction: any, a: string, b: string) {
          
          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }

          
          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      }


    },
    pager:{
      display:false
    }
  };

  constructor(private modalService: NgbModal, private networkService: NetworkService,
    private toastr: ToastrManager, private spinner: NgxSpinnerService,
    private router: Router) { }




  ngOnInit(): void {
    this.initializeListCustomer();
  }

  initializeListCustomer() {

    this.spinner.show("sp1");
    let urlUsers: string = environment.basePath + _ENDPOINT.getAllCustomer;
    let data = {
      body: ''
    }
    this.networkService.post(urlUsers, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.listCustomerView = JSON.parse(response.body);
            this.spinner.hide("sp1");

          } else if (response && response.statusCode == '500' && response.body && response.body.length > 0) {
            this.spinner.hide('sp1');
            this.toastr.errorToastr(response.body, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        } else {
          if (response && Array.isArray(response)) {
            this.listCustomerView = response;
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length>0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Customers Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }
        }
      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during Customers Retrieve', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
        });
  }

  onCustomAction(event: any) {
    switch (event.action) {
      case 'deleteAction':
        this.openDeleteModal(event.data);
        break;
      case 'editAction':
        this.openUpdateModal(event.data);
        break;

    }
  }

  openDeleteModal(elemToDelete: any) {
    let modalRef = this.modalService.open(this.confirmEliminaCustomerModal, { size: 'lg' });
    modalRef.result.then((result) => {
      if (result) {
        this.deleteCustomer(elemToDelete.globalCustomerId);
      } else {
      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  openUpdateModal(elemToUpdate: any) {

    this.modalReference = this.modalService.open(this.updateCustomerModal, { size: 'lg' });
    this.modalReference.result.then((result) => {
      if (result) {
        //this.updateCustomerService.initializeTitle(result);
        //this.updateCustomerService.initializecustomerDtoView(elemToUpdate);
        let url: string = 'update-customer/' + elemToUpdate.globalCustomerId;
        this.router.navigate([url]);

      } else {

      }
    }, (reason) => {

      /*Leave empty or handle reject*/

    });

  }

  goToAddCustomer() {
    this.router.navigate(['create-customer']);
  }

  deleteCustomer(id: string) {

    this.spinner.show("sp1");
    let urlDelete: string = environment.basePath + _ENDPOINT.deleteCustomer;
    let data = Utility.createBodyForPostRequest(id, true);
    this.networkService.post(urlDelete, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {

        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            this.deleteResponse = JSON.parse(response.body);
            if (this.deleteResponse && this.deleteResponse.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Customer deleted successfully!', 'Customer delete result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListCustomer();


            } else if (this.deleteResponse && this.deleteResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListCustomer();
            }

          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr("Error during customer delete", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            this.initializeListCustomer();
          }

        } else {

          if (response && response.status) {
            this.deleteResponse = response;
            if (this.deleteResponse && this.deleteResponse.status == 'OK') {

              this.spinner.hide("sp1");
              this.toastr.successToastr('Customer deleted successfully!', 'Customer delete result', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListCustomer();


            } else if (this.deleteResponse && this.deleteResponse.status == 'KO') {
              this.spinner.hide("sp1");
              this.toastr.errorToastr(this.deleteResponse.message, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
              this.initializeListCustomer();
            }
          } else if (response && response.length && response.length>0) {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr(response.toString(), 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          } else {
            this.spinner.hide('sp1');
            console.log(response);
            this.toastr.errorToastr('Error during Delete Customer', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          }

        }





      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr("Error during Delete Customer", 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);



        });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  goToEditCustomer() {
    this.router.navigate(['update-customer/2']);
  }


}
